import { format } from 'd3-format';

function checkNull<T>(value: T) {
  if (value === null || value === undefined) {
    return '-';
  }

  return value;
}

function roundToTenThousands(num: number) {
  return Math.floor(num / 10000) * 10000;
}

function roundToThousands(num: number) {
  return Math.floor(num / 1000) * 1000;
}
function roundToHundreds(num: number) {
  return Math.floor(num / 100) * 100;
}

function formatNumberLocale(num: number | null | undefined) {
  if (num === null || num === undefined) {
    return '-';
  }

  return num.toLocaleString('sv-SE', { maximumFractionDigits: 2 }).replace(',', '.'); // max 2 decimaler och punkt som decimaltecken
}

function formatSqmPrice(num: number) {
  return (Math.floor(num / 100) * 100).toLocaleString('sv-SE');
}

function formatNumber(value: number, decimals: number | null = null, auto: boolean = false): string {
  if (value === null || value === undefined) {
    return '-';
  } else {
    if (typeof decimals === 'number') {
      const mult = 10 ** decimals;
      value = Math.round(value * mult) / mult;
    }
    if (auto !== false && value > 0.9995e8) {
      return `${format(',.0f')(value / 1e6)} M`.replace('0,0 M', '0 M');
    } else if (auto !== false && value > 0.9995e6) {
      return `${format(',.1f')(value / 1e6)} M`.replace('0,0 M', '0 M');
    } else if (auto !== false && value > 0.9995e5) {
      return `${format(',.0f')(value / 1e3)} K`;
    } else {
      if (typeof decimals === 'number' && decimals > 0) {
        return format(`,.${decimals}f`)(value);
      } else {
        return format(',')(value);
      }
    }
  }
}

function formatBool(value: number): string | number {
  if (value === null || value === undefined) {
    return '-';
  } else if (value === 0) {
    return 'Nej';
  } else if (value === 1 || value === 100) {
    return 'Ja';
  } else {
    return value;
  }
}

function formatField(value: string): string {
  if (value === null || value === undefined) {
    return '-';
  } else {
    return value;
  }
}

function formatZipCode(value: string | number | null): string | null {
  if (value === null || value === undefined) {
    return '-';
  }
  return `${value.toString().substring(0, 3)} ${value.toString().substring(3)}`;
}

export {
  checkNull,
  formatBool,
  formatField,
  formatNumber,
  formatNumberLocale,
  formatSqmPrice,
  formatZipCode,
  roundToHundreds,
  roundToTenThousands,
  roundToThousands,
};
